// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cPwks","col":"styles_col__eGUOP"};